module.exports = __webpack_public_path__ + "static/media/BatchUploadTemplate.27693fda.zip";